module.exports = __webpack_public_path__ + "img/photo-10.e750291a.webp";